export const action = (type, payload = null) => {
    return {
        type, payload,
    }
}